import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

export { ImpactStyle, NotificationType };

// Haptic feedback that never rejects, so callers can fire and forget. On the web build,
// @capacitor/haptics falls back to navigator.vibrate and rejects where it is missing (iOS Safari,
// desktop Safari/Firefox) — an unawaited call then surfaces in Sentry as an unhandled rejection.
const run = async (call: () => Promise<void>): Promise<void> => {
  try {
    await call();
  } catch {
    // No haptics on this platform.
  }
};

export const hapticImpact = (style: ImpactStyle): Promise<void> => run(() => Haptics.impact({ style }));

export const hapticNotification = (type: NotificationType): Promise<void> =>
  run(() => Haptics.notification({ type }));
